import { inject, ref } from "vue";
import { keys } from "../data/keys";
import { mainMenu, type MenuItemKeys, type MenuKeys } from "../data/menus";

export class MenuFacade {
    private readonly activeMenu = inject(keys.activeMenu, ref({} as Record<MenuKeys, boolean>));
    private readonly activeMenuItem = inject(keys.activeMenuItem, ref());
    private menuKeys = new Map<MenuItemKeys, MenuKeys>();

    constructor() {
        mainMenu.forEach((menu) => {
            menu.items?.forEach((item) => {
                this.menuKeys.set(item.key, menu.key);
            });
        });
    }

    public reset() {
        this.activeMenu.value = {} as Record<MenuKeys, boolean>;
        this.activeMenuItem.value = undefined;
    }

    public activate(item: MenuItemKeys) {
        const menu = this.menuKeys.get(item);
        if (menu !== undefined) {
            this.activeMenu.value = { [menu]: true } as Record<MenuKeys, boolean>;
            this.activeMenuItem.value = item;
        }
    }
}
